import Icon from '@/components/ui/AppIcon';


interface SecurityFeature {
  id: string;
  icon: string;
  title: string;
  description: string;
}

interface Certification {
  id: string;
  name: string;
  logo: string;
  alt: string;
}

const securityFeatures: SecurityFeature[] = [
{
  id: 'insurance',
  icon: 'ShieldCheckIcon',
  title: 'Profesjonell gjennomføring',
  description: 'Våre erfarne medarbeidere sikrer trygg og diskret håndtering av dine verdisaker under hjemmebesøket.'
},
{
  id: 'tracking',
  icon: 'MapPinIcon',
  title: 'Avtalt tid og sted',
  description: 'Vi møter opp til avtalt tid på din adresse. Du har full kontroll over når og hvor vi kommer.'
},
{
  id: 'guarantee',
  icon: 'CheckBadgeIcon',
  title: 'Ingen forpliktelser',
  description: 'Du bestemmer selv om du vil selge. Ingen press, ingen forventninger fra vår side.'
},
{
  id: 'licensed',
  icon: 'DocumentCheckIcon',
  title: 'Ryddige rutiner',
  description: 'Vi følger faste prosedyrer for sikker håndtering og korrekt behandling.'
}];


const certifications: Certification[] = [];

const SecuritySection = () => {
  return (
    <section id="sikkerhet" className="bg-card py-12 lg:py-20">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="mb-12 text-center">
          <h2 className="font-headline text-3xl font-bold text-foreground lg:text-4xl">
            Din sikkerhet er vår prioritet
          </h2>
          <p className="mt-4 font-body text-lg text-muted-foreground lg:text-xl">
            Vi tar alle forholdsregler for å sikre en trygg og transparent prosess
          </p>
        </div>

        <div className="grid gap-8 lg:grid-cols-2">
          {securityFeatures.map((feature) =>
          <div
            key={feature.id}
            className="flex space-x-4 rounded-lg bg-background p-6 shadow-md transition-transform duration-300 hover:scale-105">

              <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-success/10">
                <Icon name={feature.icon as any} size={24} variant="solid" className="text-success" />
              </div>
              <div>
                <h3 className="font-headline text-lg font-semibold text-foreground lg:text-xl">
                  {feature.title}
                </h3>
                <p className="mt-2 font-body text-sm text-muted-foreground lg:text-base">
                  {feature.description}
                </p>
              </div>
            </div>
          )}
        </div>

        
























        <div className="mt-12 rounded-lg bg-primary/10 p-6 lg:p-8">
          <div className="flex flex-col items-center space-y-4 text-center lg:flex-row lg:space-x-6 lg:space-y-0 lg:text-left">
            <Icon name="LockClosedIcon" size={48} variant="solid" className="text-primary" />
            <div className="flex-1">
              <h3 className="font-headline text-xl font-semibold text-foreground lg:text-2xl">
                Dine data er trygge
              </h3>
              <p className="mt-2 font-body text-base text-muted-foreground">
                All kommunikasjon er kryptert, og vi følger GDPR-retningslinjer for databeskyttelse. Dine personopplysninger deles aldri med tredjeparter.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default SecuritySection;